import axios from "axios";

const API_URL = "https://api.thunderbirdsmoke.net/pos";
const API_URL_C = "https://api.thunderbirdsmoke.net";


// 🔹 Helper to add Authorization header
const authHeader = () => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("No auth token found");
  }
  return { Authorization: `Bearer ${token}` };
};

/**
 * 🔹 POS Customer APIs
 */

// Search for POS customers by phone or name
export const searchPOSCustomers = async (query: string) => {
  const response = await axios.get(`${API_URL}/customers/search`, {
    params: { query },
    headers: authHeader(),
  });
  return response.data;
};

// Create a new POS customer
export const createPOSCustomer = async (customerData: {
  name: string;
  phone: string;
  email?:string ;
}) => {
  const response = await axios.post(`${API_URL}/customers/create`, customerData, {
    headers: authHeader(),
  });
  return response.data;
};

/**
 * 🔹 POS Order APIs
 */

// Create a new POS order
// Create a new POS order
export const createPOSOrder = async (orderData: {
    customer_id?: number;
    customer_name: string;
    store_id: number;
    items: { product_id: number; variant_id: number; quantity: number }[];
    discount: { type: string; value: number };
    payment: { 
      method: string; 
      amount: number; 
      cash_received: number; 
      store_credit_used?: number;
      loyalty_points_redeemed?: number;
    };
  }) => {
    try {
      const response = await axios.post(`${API_URL}/orders/create`, orderData, {
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Error creating POS order:", error);
      throw error;
    }
  };

  

// Process POS payment
export const processPOSPayment = async (paymentData: {
  order_id: number;
  payment_method: string;
  amount: number;
  cash_received?: number;
  store_credit_used?: number;
  loyalty_points_redeemed?: number;
  store_id: number;
}) => {
  console.log("🔄 Sending POS Payment Request:", paymentData);

  try {
    const response = await axios.post(`${API_URL}/orders/payment`, paymentData, {
      headers: authHeader(),
    });

    console.log("✅ Payment API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Payment API Error:", error);
    throw error;
  }
};


/**
 * 🔹 POS Loyalty APIs (Secured with Auth Headers)
 */

// Get customer loyalty balance
export const getPOSCustomerLoyalty = async (customerId: number, storeId: number) => {
    if (!storeId) {
        console.error("Store ID is missing!");
        throw new Error("Store ID is required");
    }
    
    const response = await axios.get(`${API_URL}/loyalty/${customerId}/${storeId}`, {
        headers: authHeader(),
    });

    return response.data;
};  





// Get loyalty settings (Admin Only)
export const getLoyaltySettings = async () => {
  const response = await axios.get(`${API_URL}/loyalty/settings`, { headers: authHeader() });
  return response.data;
};

// Update loyalty settings (Admin Only)
export const updateLoyaltySettings = async (percentage: number) => {
  const response = await axios.post(`${API_URL}/loyalty/settings`, { percentage }, { headers: authHeader() });
  return response.data;
};


// 🔹 Process Clover Payment (Credit/Debit Card Transactions)
export const processCloverPayment = async (paymentData: {
  order_id: number;
  amount: number;
  store_id: number;
  customer_id?: number;
  card_type: "credit" | "debit"; // ✅ New field to differentiate credit vs. debit payments
}) => {
  console.log("💳 Sending Clover Payment Request:", paymentData);

  try {
    const response = await axios.post(`${API_URL}/clover/pay`, paymentData, {
      headers: authHeader(),
    });

    console.log("✅ Clover Payment Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Clover Payment API Error:", error);
    throw error;
  }
};



// Clover OAuth API
export const initiateCloverOAuth = async () => {
  const response = await axios.get(`${API_URL_C}/clover/initiate`, {
    headers: authHeader(),
  });
  return response.data;
};

export const checkCloverOAuthStatus = async (merchantId: string) => {
  const response = await axios.get(`${API_URL_C}/clover/status`, {
    params: { merchant_id: merchantId },
    headers: authHeader(),
  });
  return response.data;
};


export const processCloverRestPayment = async (order_id: number, amount: number) => {
  const response = await axios.post(`${API_URL}/orders/clover-rest-pay`, { order_id, amount }, { headers: authHeader() });
  return response.data;
};
